import React from "react";
import { matchGovRoute, govMeta } from "@/lib/governance";
import { GovNavContext } from "@/components/governance/GovShell";
import { GovernanceOverview } from "@/pages/governance/GovernanceOverview";
import { GovPlaceholder } from "@/pages/governance/GovPlaceholder";
import { ProposalsList } from "@/pages/governance/ProposalsList";
import { ProposalDetail } from "@/pages/governance/ProposalDetail";
import { DrepsList } from "@/pages/governance/DrepsList";
import { DrepDetail } from "@/pages/governance/DrepDetail";
import { Committee } from "@/pages/governance/Committee";
import { CommitteeMember } from "@/pages/governance/CommitteeMember";
import { PoolVoting } from "@/pages/governance/PoolVoting";
import { Parameters } from "@/pages/governance/Parameters";
import { Treasury } from "@/pages/governance/Treasury";
import { Withdrawals } from "@/pages/governance/Withdrawals";
import { Constitution } from "@/pages/governance/Constitution";
import { ConstitutionHistory } from "@/pages/governance/ConstitutionHistory";

// Governance sub-router. App.js owns the browser URL + history; this maps the
// current /governance/* path to a page and exposes `navigate` to all children.
export const GovernanceRouter = ({ path, navigate }) => {
  const { key, params } = matchGovRoute(path);
  const meta = govMeta(key, params);

  let page;
  switch (key) {
    case "overview": page = <GovernanceOverview meta={meta} />; break;
    case "proposals": page = <ProposalsList meta={meta} mode="all" />; break;
    case "proposalsLive": page = <ProposalsList meta={meta} mode="live" />; break;
    case "proposal": page = <ProposalDetail key={`${params.txHash}-${params.certIndex}`} meta={meta} txHash={params.txHash} certIndex={params.certIndex} />; break;
    case "dreps": page = <DrepsList meta={meta} />; break;
    case "drep": page = <DrepDetail key={params.drepId} meta={meta} drepId={params.drepId} />; break;
    case "committee": page = <Committee meta={meta} />; break;
    case "committeeMember": page = <CommitteeMember key={params.coldId} meta={meta} coldId={params.coldId} />; break;
    case "pools": page = <PoolVoting meta={meta} />; break;
    case "pool": page = <PoolVoting key={params.poolId} meta={meta} poolId={params.poolId} />; break;
    case "parameters": page = <Parameters meta={meta} />; break;
    case "treasury": page = <Treasury meta={meta} />; break;
    case "withdrawals": page = <Withdrawals meta={meta} />; break;
    case "constitution": page = <Constitution meta={meta} />; break;
    case "constitutionHistory": page = <ConstitutionHistory meta={meta} />; break;
    default: page = <GovPlaceholder meta={meta} />; break;
  }

  return <GovNavContext.Provider value={navigate}>{page}</GovNavContext.Provider>;
};
